import React, { useState, useEffect } from "react";
import axios from "axios";
import { Tabs, Tab, Box } from "@mui/material";
import { DataGridPremium, GridToolbar } from "@mui/x-data-grid-premium";

const ConsolidatedMonthly = ({ startDate, endDate, token }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tabValue, setTabValue] = useState(0);
  // const [pageSize, setPageSize] = useState(5);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/reports/CallCentreSalesReports/ConsolidatedMonthlySBIReport?startDate=${startDate}&endDate=${endDate}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        // Transform the data to add unique IDs
        const transformedData = response.data.data.map((item, index) => ({
          ...item,
          id: index + 1,
        }));

        setData({ ...response.data, data: transformedData });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (startDate && endDate) {
      fetchData();
    }
  }, [startDate, endDate, token]);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const salesColumns = [
    {
      field: "month_start_date",
      headerName: "Month",
      flex: 1,
      valueFormatter: (params) => {
        return new Date(params.value).toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
        });
      },
    },
    { field: "target_sales", headerName: "Target Sales", flex: 1 },
    { field: "total_sales", headerName: "Total Sales", flex: 1 },
    { field: "sales", headerName: "Sales", flex: 1 },
    {
      field: "sales_percentage",
      headerName: "Sales % Target",
      flex: 1,
      valueGetter: (params) => {
        const totalSales = params.row.total_sales || 0;
        const targetSales = params.row.target_sales;
        if (targetSales === 0 || !targetSales) return "";
        return ((totalSales / targetSales) * 100).toFixed(0) + "%";
      },
    },
  ];

  const biColumns = [
    {
      field: "month_start_date",
      headerName: "Month",
      flex: 1,
      valueFormatter: (params) => {
        return new Date(params.value).toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
        });
      },
    },
    {
      field: "total_bi",
      headerName: "Total BI",
      flex: 1,
      valueFormatter: (params) => parseFloat(params.value).toFixed(2),
    },
    {
      field: "sales_bi",
      headerName: "Sales BI",
      flex: 1,
      valueFormatter: (params) => parseFloat(params.value).toFixed(2),
    },
    {
      field: "target_bi",
      headerName: "Target BI",
      flex: 1,
      valueFormatter: (params) => parseFloat(params.value).toFixed(2),
    },
  ];

  const hoursLeadsColumns = [
    {
      field: "month_start_date",
      headerName: "Month",
      flex: 1,
      valueFormatter: (params) => {
        return new Date(params.value).toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
        });
      },
    },
    { field: "target_hours", headerName: "Target Hours", flex: 1 },
    {
      field: "campaign_hours",
      headerName: "Campaign Hours",
      flex: 1,
      valueFormatter: (params) => parseFloat(params.value).toFixed(2),
    },
    { field: "leads", headerName: "Leads", flex: 1 },
    { field: "target_leads", headerName: "Target Leads", flex: 1 },
  ];

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!data || data.data.length === 0) return <h3>No Data Available</h3>;

  return (
    <div>
      <Tabs value={tabValue} onChange={handleChange} aria-label="tabs">
        <Tab label="Sales" />
        <Tab label="Hours & Leads" />
        <Tab label="BI" />
      </Tabs>

      <Box sx={{ marginTop: 2 }}>
        {tabValue === 0 && (
          <DataGridPremium
            autoHeight
            rows={data.data}
            columns={salesColumns}
            slots={{ toolbar: GridToolbar }}
            // pagination
            // pageSize={pageSize}
            // onPageSizeChange={(newSize) => setPageSize(newSize)}
            // initialState={{
            //   pagination: { paginationModel: { pageSize: 10 } },
            // }}
            // pageSizeOptions={[5, 10, 15, 20]}
          />
        )}
        {tabValue === 1 && (
          <DataGridPremium
            autoHeight
            rows={data.data}
            columns={hoursLeadsColumns}
            slots={{ toolbar: GridToolbar }}
            // pagination
            // pageSize={pageSize}
            // onPageSizeChange={(newSize) => setPageSize(newSize)}
            // initialState={{
            //   pagination: { paginationModel: { pageSize: 10 } },
            // }}
            // pageSizeOptions={[5, 10, 15, 20]}
          />
        )}
        {tabValue === 2 && (
          <DataGridPremium
            autoHeight
            rows={data.data}
            columns={biColumns}
            slots={{ toolbar: GridToolbar }}
            // pagination
            // pageSize={pageSize}
            // onPageSizeChange={(newSize) => setPageSize(newSize)}
            // initialState={{
            //   pagination: { paginationModel: { pageSize: 10 } },
            // }}
            // pageSizeOptions={[5, 10, 15, 20]}
          />
        )}
      </Box>
    </div>
  );
};

export default ConsolidatedMonthly;
